import { eventTypes } from '@luxuryescapes/contract-support'

/**
 * Leaf socket event constants for the support assistant.
 * Kept out of api/supportAssistant so useSocket can subscribe without
 * the api/supportAssistant ↔ useSocket cycle.
 */
export const { CONNECTION, SESSION } = eventTypes
